import { all } from 'redux-saga/effects';

import receiptSaga from 'apps/modules/receipt/ReceiptSaga';

export default function*() {
  yield all([receiptSaga()]);
}
